export default __webpack_public_path__ + "static/media/ubuntu-icon.9cba3da9.svg";